<template src='./user-information.html'></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage.vue'
import { hasUserManageClaim, hasOrganizationManageClaim } from '@/router/auth'
import { EventBus } from '@/router/bus'
import securityStore from '@/store/security-store'

export default {
  components: {
    ContextPage
  },
  data () {
    return {
      editMode: false,
      login: this.$route.params.login,
      loggedUserOrganizationId: '',
      phoneNumberMask: '(##) ### ####',
      status: [
        {
          color: 'success',
          text: this.$t('status.Active')
        },
        {
          color: 'pending',
          text: this.$t('status.Inactive')
        },
        {
          color: 'error',
          text: this.$t('status.Revoked')
        },
        {
          color: 'error',
          text: this.$t('status.RevokedAccess')
        }
      ],
      claimType: {
        System: 1,
        Feature: 2,
        AdminOnly: 3
      },
      help: {
        details: Vue.$helpConfig.userDetails
      },
      availableRoles: [],
      user: {},
      loading: false,
      userClaims: [],
      userRoles: [],
      dataTableRoles: [],
      newUserClaims: [],
      newUserRoles: [],
      newDataTableRoles: [],
      userHasDataTableClaims: [],
      userHasSomeSystemRoles: false,
      userHasSomeSystemClaims: false,
      userHasSomeDataTableClaims: false,
      privilegesChanging: false,
      nameRules: [
        v =>
          !!(v && v.length !== 0 && v.trim()) ||
          this.$t('validation.nameRequired')
      ],
      emailRules: [
        v =>
          !!(v && v.length !== 0 && v.trim()) ||
          this.$t('validation.emailRequired'),
        v => /.+@.+\..+/.test(v) || this.$t('validation.emailRequired')
      ],
      restoreDialog: false,
      restoreLoading: false,
      revokeDialog: false,
      revokeLoading: false,
      UserStatus: {
        ACTIVE: 1,
        INACTIVE: 2,
        REVOKED: 3,
        REVOKEDACCESS: 4
      },
      newComment: ''
    }
  },
  computed: {
    canEditUser () {
      return this.user && hasUserManageClaim()
    },
    canEditOrganization () {
      return this.user && hasOrganizationManageClaim()
    }
  },
  created () {
    this.setupPage()
    this.loggedUserOrganizationId = securityStore.getters.organizationId
  },
  methods: {
    setupPage () {
      this.loading = true
      const login = this.$route.params.login
      const infoUrl = Vue.$apiConfig.userInformationGet + '/' + login
      this.userRoles = []
      this.$http.get(infoUrl).then(
        response => {
          this.logConsole(response)
          this.user = response.data.payload
          this.loading = false
        },
        error => {
          this.formatErrorResponse(error)
          this.loading = false
        }
      )
    },
    openEditMode () {
      this.retrieveRoles()
      this.editMode = true
    },
    revokeUser () {
      const requestBody = {
        access: this.loggedUserOrganizationId === '00000' ? 'Disabled' : 'Revoked',
        Users: [
          {
            login: this.user.login,
            modifiedComments: this.newComment
          }
        ]
      }
      this.loading = true
      this.$http.post(Vue.$apiConfig.userRevokeAccessPost, requestBody).then(
        response => {
          Vue.use(response)
          if (response.data.payload[0].error) {
            EventBus.$emit('alert', {
              variant: 'error',
              message: this.$t('apiStatusCodes.' + response.data.payload[0].error.code),
              errors: []
            })
          } else {
            this.user.status = response.data.payload[0].model.status
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('profile.statusRestore'),
              errors: []
            })
          }
          this.loading = false
          this.revokeDialog = false
        },
        error => {
          this.formatErrorResponse(error)
          this.loading = false
          this.revokeDialog = false
        }
      )
    },
    activateUser () {
      const requestBody = {
        access: 'Active',
        Users: [
          {
            login: this.user.login,
            modifiedComments: 'ACTIVATE'
          }
        ]
      }
      this.loading = true
      this.$http.post(Vue.$apiConfig.userRestoreAccessPost, requestBody).then(
        response => {
          Vue.use(response)
          if (response.data.payload[0].error) {
            EventBus.$emit('alert', {
              variant: 'error',
              message: this.$t('apiStatusCodes.' + response.data.payload[0].error.code),
              errors: []
            })
          } else {
            this.user.status = response.data.payload[0].model.status
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('profile.statusActivate'),
              errors: []
            })
          }
          this.loading = false
          this.restoreDialog = false
        },
        error => {
          this.formatErrorResponse(error)
          this.loading = false
          this.restoreDialog = false
        }
      )
    },
    changeInfo () {
      this.loading = true
      if (this.$refs.formInformation.validate()) {
        this.$http.put(Vue.$apiConfig.createUserPost, [this.user]).then(
          response => {
            this.logConsole(response)
            const user = response.data.payload[0].model
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t(
                'userAdministration.userInformationUpdateSuccess'
              ),
              errors: []
            })
            this.user.name = user.name
            this.user.email = user.email
            this.user.phoneNumber = user.phoneNumber
            this.user.loginAd = user.loginAd
            this.user.roleName = this.availableRoles.find(x => x.id === this.user.roleId).name
            this.user.roleDescription = this.availableRoles.find(x => x.id === this.user.roleId).description
            this.editMode = false
            this.loading = false
          },
          error => {
            this.formatErrorResponse(error)
            this.loading = false
          }
        )
      }
    },
    retrieveRoles () {
      this.loading = true
      this.$http.get(Vue.$apiConfig.availableRolesGet).then(
        response => {
          this.logConsole(response)
          this.availableRoles = response.data.payload
          this.privilegesChanging = true
          this.loading = false
        },
        error => {
          this.formatErrorResponse(error)
          this.loading = false
        }
      )
    },
    gotoRoleDescription () {
      this.$router.push('/administration/role/' + this.user.roleId)
    },
    gotoOrganization () {
      if (this.canEditOrganization) {
        this.$router.push('/administration/organization/' + this.user.organizationId)
      } else {
        this.$router.push('/registry/organization/' + this.user.organizationId)
      }
    },
    sendActivationEmail () {
      this.loading = true
      this.logConsole('Sending activate user request')
      this.$http.put(Vue.$apiConfig.activateUserPut.replace('{login}', this.user.login), this.user)
        .then(response => {
          this.loading = false
          EventBus.$emit('alert', {
            variant: 'success',
            message: this.$t('activation.activationSent'),
            errors: []
          })
        }, error => {
          this.logConsole(error)
          this.loading = false
          this.formatErrorResponse(error)
        })
    }
  }
}
</script>

<style>
.v-chip {
  font-weight: 600 !important;
  /* font-size: 20px !important */
}
.item-container {
  font-weight: 600 !important;
  font-size: 15px !important;
}

.drop-menu-item {
  margin: 0 0 0 50px;
}
.claim-item {
  font-size: 15px;
  font-weight: 300;
  line-height: 1;
  letter-spacing: 0.02em;
  font-family: 'Source Sans Pro', sans-serif;
  margin-left: 30px;
}

.centered-label {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.list-container {
  height: 264px;
  overflow-y: auto;
  font-size: 11pt;
  border: 1px solid rgba(0, 0, 0, .12);
}
</style>
